import { Maths } from 'helpers/maths';
import { getPlanProperties } from '../../helpers/dataHelpers';

// This field is on a 0-100 scale here (unlike the Plan's own `coveragePct`,
// a 0-1 fraction), so a missing/invalid value falls back to 100, matching
// this function's prior hardcoded default.
const toCoveragePercent = (coveragePct, areaValue, cropZone) => {
  if (coveragePct != null && Number.isFinite(coveragePct)) {
    return Maths.multiplyRound(coveragePct, 100, 2);
  }

  const denominator =
    cropZone?.reportedArea === 0
      ? cropZone?.boundaryArea
      : cropZone?.reportedArea || cropZone?.boundaryArea;
  return denominator > 0
    ? Maths.multiplyRound(
        Maths.divide(areaValue ?? denominator, denominator),
        100,
        2
      )
    : 100;
};

// eslint-disable-next-line import/prefer-default-export
export const mapProperties = (
  cropZones,
  propertyLandingPageData,
  fieldsAndAreasGeoJSONCollection,
  values
) => {
  const mappedProperties = cropZones.map(cropZone => {
    const planProps = getPlanProperties(
      propertyLandingPageData,
      [cropZone.cropZoneIdValue],
      fieldsAndAreasGeoJSONCollection,
      values
    );
    return {
      areaType: cropZone?.boundaryAreaUnit || '',
      areaUnit: 'acres',
      areaValue: cropZone?.areaValue || '',
      boundaryArea: cropZone?.boundaryArea || '',
      coveragePct: toCoveragePercent(
        cropZone?.coveragePct,
        cropZone?.areaValue,
        planProps[0]
      ),
      crop: {
        id:
          planProps[0]?.crop?.id ||
          cropZone?.cropId ||
          values?.cropId?.$id ||
          values?.cropId ||
          '',
        name: ''
      },
      cropZoneId: cropZone?.cropZoneIdValue || '',
      farmId: planProps[0]?.farmId || '',
      name: cropZone?.name || '',
      reportedArea: cropZone?.reportedArea || ''
    };
  });

  return mappedProperties;
};
